import {Pagination} from "@/models";

export interface ParamService {
    'megalist-page': number;
    'megalist-batchSize': number;
    'megalist-sort'?: string;
    'megalist-sortOrder'?: string;
}

export const paramService = (
        pagination: Pagination | null, 
        autoIncrement: boolean, 
        sort: string | null = null, 
        sortOrder: string | null = null
    ): ParamService => {

    let page = pagination ? pagination.currentPage : 1;
    const batch = pagination ? pagination.perPage : 25;

    if (autoIncrement) {
        page++;
    }

    return {
        'megalist-page': page,
        'megalist-batchSize': batch,
        'megalist-sort': sort ?? undefined,
        'megalist-sortOrder': sortOrder ?? undefined,
    };
}